import { extendObservable, computed } from 'mobx';
import axios from '../../../libs/axios_csrf';
import { STARTUPS_PER_PAGE } from '../constants';

export default class Grow {
  constructor(rootStore) {
    this.rootStore = rootStore;
    this.fetchData();

    extendObservable(this, {
      startups: [],
      users: [],
      tools: [],
      filterText: '',
      timeTracks: [],
      totalStartup: 0,
      totalUsers: 0,
      activeStartup: 0,
      loaded: false,
      startupsPage: 1,
      usersPage: 1,
      reverse: false,
      cmp: function(a, b) {
        if (a.name.toLowerCase() > b.name.toLowerCase()) {
          return 1;
        }
        if (a.name.toLowerCase() < b.name.toLowerCase()) {
          return -1;
        }
        return 0;
      }
    });
  }

  setFilterText(filter) {
    this.filterText = filter;
  }

  fetchData() {
    axios
      .get('/startup_statistics/action_manager/grow', {
        params: {
          //  users_page: this.nextUsersPage,
          startups_page: this.nextStartupsPage,
          per_page: STARTUPS_PER_PAGE
        }
      })
      .then(response => {
        this.totalStartup = response.data['startups']['total'];
        this.activeStartup = response.data['startups']['active'];
        //  this.totalUsers = response.data["users"];

        // console.log('Response: ', response);

        const concatenatedStartups = this.startups.concat(
          response.data['startups_info']['startups_usage']
        );
        const concatenatedTimeTracks = this.timeTracks.concat(
          response.data['startups_info']['time_tracks']
        );
        //   const concatenatedUsers = this.users.concat(response.data["users_info"]["list"])

        if (this.totalStartup != this.startups.length)
          this.startups = Array.from(new Set(concatenatedStartups));

        /*  if(this.totalUsers != this.users.length){
                      this.users = Array.from(new Set(concatenatedUsers));
                  }
                  */
        this.timeTracks = Array.from(new Set(concatenatedTimeTracks));
        this.tools = response.data['tools_info'];
        this.nextStartupsPage = response.data['startups_info']['next_page'];
        //  this.nextUsersPage = response.data["users_info"]["next_page"]
        this.loaded = true;
        if (this.nextStartupsPage) {
          this.fetchData();
        }
      })
      .catch(error => {
        console.log('STARTUPS FETCH FAILED!', error);
      });
  }

  nextStartups() {
    this.startupsPage++;
  }

  prevStartups() {
    this.startupsPage--;
  }

  nextUsers() {
    this.usersPage++;
  }

  prevUsers() {
    this.usersPage--;
  }

  @computed
  get filteredStartups() {
    if (this.filterText.length === 0) {
      return this.startups;
    } else {
      var filterSlash = this.filterText.toLowerCase().replace(/\\/g, '');

      var retVal = this.startups.filter(p =>
        p.name.toLowerCase().match(filterSlash)
      );
      return retVal;
    }
  }

  @computed
  get sorted() {
    return this.filteredStartups.sort(this.cmp);
  }

  @computed
  get retrieveUsers() {
    return this.users.slice(
      (this.usersPage - 1) * STARTUPS_PER_PAGE,
      this.usersPage * STARTUPS_PER_PAGE
    );
  }

  @computed
  get retrieveStartups() {
    const a = this.sorted.slice();

    if (this.reverse) a.reverse();

    var v = a.slice(
      (this.startupsPage - 1) * STARTUPS_PER_PAGE,
      this.startupsPage * STARTUPS_PER_PAGE
    );
    return v;
  }

  @computed
  get full() {
    return (
      Math.ceil(this.filteredStartups.length / STARTUPS_PER_PAGE) ===
      this.startupsPage
    );
  }

  @computed
  get disableNextStartups() {
    return this.full;
  }

  @computed
  get disablePrevStartups() {
    return this.startupsPage === 1;
  }

  @computed
  get disableNextUsers() {
    return Math.ceil(this.users.length / STARTUPS_PER_PAGE) === this.usersPage;
  }

  @computed
  get disablePrevUsers() {
    return this.usersPage === 1;
  }

  @computed
  get startupTotal() {
    return this.totalStartup;
  }

  @computed
  get startupActive() {
    return this.activeStartup;
  }

  get getComparisonCriteria() {
    return {
      name: function(a, b) {
        if (a.name.toLowerCase() > b.name.toLowerCase()) {
          return 1;
        }
        if (a.name.toLowerCase() < b.name.toLowerCase()) {
          return -1;
        }
        return 0;
      },
      consecutiveDays: (a, b) => {
        return a.consecutive_days_login - b.consecutive_days_login;
      },
      lastLogin: (a, b) =>
        new Date(a.last_login).getTime() - new Date(b.last_login).getTime(),
      monthlyLoginCount: (a, b) => {
        return a.monthly_login - b.monthly_login;
      },
      totalLoginCount: (a, b) => {
        return a.total_login - b.total_login;
      }
    };
  }

  findStartupById(id) {
    let retVal = this.startups.find(p => p.id === +id);

    retVal['timeTracker'] = this.timeTracks.find(p => p.id === retVal.id);

    return retVal;
  }

  getData(id, label) {
    const startup = this.findStartupById(id);

    if (startup.timeTracker.tools === null) {
      startup.timeTracker.tools = ['none', 0];
    }

    const x = Object.keys(startup.login_history);

    var xAxis = [];
    var yAxis = [];

    const format = {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    };

    ///Interpolation
    for (
      let d = new Date(x[0]), i = 0;
      d <= new Date(x[x.length - 1]);
      d.setDate(d.getDate() + 1), i++
    ) {
      const stringDate = d.toLocaleDateString('en-GB', format).replace(',', '');
      xAxis.push(stringDate);
      const value = startup.login_history[stringDate];
      value === undefined ? yAxis.push(0) : yAxis.push(value);
    }

    return {
      labels: xAxis,
      datasets: [
        {
          label: label, // "", {//intl.formatMessage({id: this.props.entry})},
          fill: false,
          lineTension: 0.1,
          backgroundColor: 'rgba(75,192,192,0.4)',
          borderColor: 'rgba(75,192,192,1)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgba(75,192,192,1)',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'rgba(75,192,192,1)',
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: yAxis
        }
      ]
    };
  }

  @computed
  get mostUsedTools() {
    return this.tools;
  }
}
